// extracted by mini-css-extract-plugin
export var root = "iZOR";
export var rootArrow = "ZmHR";
export var rootArrows = "ctN8";
export var rootCarousel = "QwJ4";
export var rootCarouselContainer = "cQHd";
export var rootContainer = "VvHc";
export var rootDot = "O9VQ";
export var rootDotActive = "rkmE";
export var rootDots = "gqbV";
export var rootFigure = "nKgi";
export var rootFigureActive = "Qdf2";
export var rootHeader = "_5kGJ";
export var rootHeading = "KVat";
export var rootIntro = "IkGM";
export var rootLink = "Ag1c";
export var rootPagination = "sBMV";
export var rootPlayIcon = "fokM";
export var rootRating = "vB6V";
export var rootRatingLogo = "TT-7";
export var rootRatingStars = "Og30";
export var rootRatingText = "aQFr";
export var rootRatingValue = "v3ur";
export var rootSlide = "_2nSW";
export var rootSlider = "qjHs";
export var rootVideo = "Y37R";